import { DevelopmentalData } from "@/types/developmental";

export const infantMilestones: DevelopmentalData = {
  motor: [
    "Lifts head and chest when lying on stomach",
    "Reaches for and grasps objects",
    "Rolls over in both directions",
    "Begins to sit without support",
    "May start crawling",
  ],
  language: [
    "Responds to sounds and voices",
    "Begins to babble and imitate sounds",
    "Makes cooing sounds",
    "Turns head toward sounds",
    "Shows excitement through vocalizations",
  ],
  cognitive: [
    "Recognizes familiar faces",
    "Follows moving objects with eyes",
    "Shows curiosity about surroundings",
    "Starts understanding object permanence",
    "Explores objects with mouth",
  ],
  independent: [
    "Brings hands to mouth",
    "Tries to reach for toys",
    "Shows preferences for certain people",
    "Begins to self-soothe",
    "Responds to own name",
  ],
  social: [
    "Smiles at people",
    "Enjoys playing with others",
    "May cry when playing stops",
    "Copies facial expressions",
    "Shows different emotions",
  ],
};